<template>
  <div class="product-preview">
    <button class="btn-back" v-if="!attribute.addToCart" @click="$emit('close')">
      <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M5.2903 0.387101L5.20711 0.292893C4.84662 -0.0675907 4.27939 -0.0953203 3.8871 0.209705L3.79289 0.292893L0.792893 3.29289L0.751496 3.33685L0.696335 3.40469L0.624671 3.51594L0.571225 3.62866L0.535845 3.73401L0.506907 3.8819L0.5 4L0.502788 4.07524L0.52024 4.20073L0.549738 4.31214L0.593673 4.42322L0.645995 4.52071L0.719689 4.62545L0.792893 4.70711L3.79289 7.70711C4.18342 8.09763 4.81658 8.09763 5.20711 7.70711C5.56759 7.34662 5.59532 6.77939 5.2903 6.3871L5.20711 6.29289L3.915 5L11.5 5C12.0523 5 12.5 4.55228 12.5 4C12.5 3.44772 12.0523 3 11.5 3L3.915 3L5.20711 1.70711C5.56759 1.34662 5.59532 0.779392 5.2903 0.387101L5.20711 0.292893L5.2903 0.387101Z"
              fill="#3C3C3C"/>
      </svg>
      Cofnij
    </button>
    <div class="inner" data-simplebar v-if="!attribute.addToCart">
      <div class="product-image-wrap">
        <img :src="attribute.product.image"/>
      </div>
      <div class="product-info">
        <div class="name">
          <h4>{{ attribute.product.name }}</h4>
          <p>{{ attribute.description }}</p>
        </div>
        <div class="add-to-cart">
          <button class="btn-cart" @click="showAddToCart = true">
            Zamów bezpłatną próbkę
            <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M3.69961 10.9996C4.36235 10.9996 4.89961 11.5369 4.89961 12.1996C4.89961 12.8624 4.36235 13.3996 3.69961 13.3996C3.03687 13.3996 2.49961 12.8624 2.49961 12.1996C2.49961 11.5369 3.03687 10.9996 3.69961 10.9996ZM9.29961 10.9996C9.96235 10.9996 10.4996 11.5369 10.4996 12.1996C10.4996 12.8624 9.96235 13.3996 9.29961 13.3996C8.63687 13.3996 8.09961 12.8624 8.09961 12.1996C8.09961 11.5369 8.63687 10.9996 9.29961 10.9996ZM0.899609 0.599609H2.49961C2.90988 0.599609 3.24802 0.908442 3.29423 1.30631L3.29961 1.39961V2.19961H12.0996C12.5998 2.19961 12.9692 2.65024 12.8892 3.12933L12.8688 3.21939L11.6004 7.65894C11.3194 8.64243 10.4486 9.33437 9.43799 9.39524L9.29273 9.39961H4.09961C2.82146 9.39961 1.77668 8.40047 1.70368 7.14063L1.69961 6.99961V2.19961H0.899609C0.457782 2.19961 0.0996094 1.84144 0.0996094 1.39961C0.0996094 0.989341 0.408442 0.651204 0.806313 0.604992L0.899609 0.599609H2.49961H0.899609ZM11.039 3.79961H3.29961V6.99961C3.29961 7.40988 3.60844 7.74802 4.00631 7.79423L4.09961 7.79961H9.29273C9.61744 7.79961 9.90639 7.60392 10.03 7.31031L10.0619 7.21939L11.039 3.79961Z"
                    fill="#3C3C3C"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="product-description" v-html="renderHTML(attribute.product.description)"></div>

      <div class="product-features-wp">
        <div class="feature" v-for="feature in attribute.product.features">
          <div class="icon"><img :src="feature.icon"/></div>
          <div class="caption">
            <h5>{{ feature.title }}</h5>
            <p>{{ feature.text }}</p>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="cart-prompt" v-if="showAddToCart">
        <div class="inner">
          <button class="btn-back" @click="attribute.addToCart && showAddToCart ? $emit('close') : showAddToCart = false">
            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5.2903 0.387101L5.20711 0.292893C4.84662 -0.0675907 4.27939 -0.0953203 3.8871 0.209705L3.79289 0.292893L0.792893 3.29289L0.751496 3.33685L0.696335 3.40469L0.624671 3.51594L0.571225 3.62866L0.535845 3.73401L0.506907 3.8819L0.5 4L0.502788 4.07524L0.52024 4.20073L0.549738 4.31214L0.593673 4.42322L0.645995 4.52071L0.719689 4.62545L0.792893 4.70711L3.79289 7.70711C4.18342 8.09763 4.81658 8.09763 5.20711 7.70711C5.56759 7.34662 5.59532 6.77939 5.2903 6.3871L5.20711 6.29289L3.915 5L11.5 5C12.0523 5 12.5 4.55228 12.5 4C12.5 3.44772 12.0523 3 11.5 3L3.915 3L5.20711 1.70711C5.56759 1.34662 5.59532 0.779392 5.2903 0.387101L5.20711 0.292893L5.2903 0.387101Z"
                    fill="#3C3C3C"/>
            </svg>
            Cofnij
          </button>
          <div class="product-image-wrap">
            <img :src="attribute.product.image"/>
          </div>
          <div class="name">{{ attribute.product.name }}</div>
          <span class="group">{{ attribute.group.name }}</span>

          <button class="btn-cart" @click="performAddToCart(attribute.product.id)">
            Dodaj do koszyka
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5 13.5C5.82843 13.5 6.5 14.1716 6.5 15C6.5 15.8284 5.82843 16.5 5 16.5C4.17157 16.5 3.5 15.8284 3.5 15C3.5 14.1716 4.17157 13.5 5 13.5ZM12 13.5C12.8284 13.5 13.5 14.1716 13.5 15C13.5 15.8284 12.8284 16.5 12 16.5C11.1716 16.5 10.5 15.8284 10.5 15C10.5 14.1716 11.1716 13.5 12 13.5ZM1.5 0.5H3.5C4.01284 0.5 4.43551 0.88604 4.49327 1.38338L4.5 1.5V2.5H15.5C16.1253 2.5 16.587 3.06329 16.487 3.66215L16.4615 3.77472L14.876 9.32416C14.5247 10.5535 13.4362 11.4185 12.173 11.4945L11.9914 11.5H5.5C3.90232 11.5 2.59634 10.2511 2.50509 8.67627L2.5 8.5V2.5H1.5C0.947715 2.5 0.5 2.05228 0.5 1.5C0.5 0.987164 0.88604 0.564493 1.38338 0.506728L1.5 0.5H3.5H1.5ZM14.1743 4.5H4.5V8.5C4.5 9.01284 4.88604 9.43551 5.38338 9.49327L5.5 9.5H11.9914C12.3973 9.5 12.7585 9.25539 12.9129 8.88838L12.9529 8.77472L14.1743 4.5Z"
                    fill="white"/>
            </svg>
          </button>

          <div class="shipping">
            <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.57678 1.5L1.5 1.5L1.5 8.49988L9.57678 8.49988L9.57678 1.5Z" stroke="#45BF7A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.57715 4.19238L11.731 4.19238L13.3463 5.80774V8.5H9.57715L9.57715 4.19238Z" stroke="#45BF7A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path
                  d="M3.92328 11.1923C4.66673 11.1923 5.26941 10.5896 5.26941 9.84613C5.26941 9.10268 4.66673 8.5 3.92328 8.5C3.17983 8.5 2.57715 9.10268 2.57715 9.84613C2.57715 10.5896 3.17983 11.1923 3.92328 11.1923Z"
                  stroke="#45BF7A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path
                  d="M10.9233 11.1923C11.6667 11.1923 12.2694 10.5896 12.2694 9.84613C12.2694 9.10268 11.6667 8.5 10.9233 8.5C10.1798 8.5 9.57715 9.10268 9.57715 9.84613C9.57715 10.5896 10.1798 11.1923 10.9233 11.1923Z"
                  stroke="#45BF7A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Darmowa dostawa
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="cart-prompt" v-if="addedToCart">
        <div class="inner compact">
          <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg"
               style="margin-bottom: 15px;">
            <path
                d="M0 28.5C0 12.7599 12.7599 0 28.5 0C44.2401 0 57 12.7599 57 28.5C57 44.2401 44.2401 57 28.5 57C12.7599 57 0 44.2401 0 28.5Z"
                fill="#45BF7A"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M26.9101 34.4959L20.7071 28.2929C20.3166 27.9024 19.6834 27.9024 19.2929 28.2929C18.9024 28.6835 18.9024 29.3166 19.2929 29.7071L26.2929 36.7071C26.7168 37.1311 27.4159 37.0893 27.7863 36.6179L38.7863 22.6179C39.1275 22.1836 39.0521 21.5549 38.6178 21.2137C38.1835 20.8725 37.5549 20.9479 37.2137 21.3822L26.9101 34.4959Z"
                  fill="white"/>
          </svg>

          <div class="name">Dodano próbkę do koszyka</div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import {mapActions} from "vuex";
import clickOutside from '../../directives/clickOutside'

export default {
  name: "ProductPreview",
  props: {
    attribute: {
      type: Object
    }
  },
  directives: {
    clickOutside: clickOutside
  },
  data() {
    return {
      showAddToCart: false,
      addingToCart: false,
      addedToCart: false
    }
  },
  mounted() {
    if (this.attribute.addToCart) {
      this.showAddToCart = true
    }
  },
  methods: {
    ...mapActions({
      addToCartFabric: 'customizer/addToCartFabric'
    }),
    performAddToCart(product) {
      this.addingToCart = true
      this.showAddToCart = false
      this.addedToCart = true
      this.addToCartFabric({product_id: product}).then(() => {
        this.addingToCart = false

        if (this.attribute.addToCart) {
          setTimeout(() => {
            this.addedToCart = false
            this.$emit('close')
          }, 1500)
        } else {
          setTimeout(() => this.addedToCart = false, 1500)
        }
      })
    },
    renderHTML(str) {
      let txt = document.createElement('textarea')
      txt.innerHTML = str
      return txt.value
    },
    closeDialog() {
      if (this.attribute.addToCart) {
        this.$emit('closeAll')
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.product-preview {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  z-index: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 480px) {
    position: fixed;
  }

    .btn-back {
    border: 0;
    margin: 0;
    background: none;
    font-weight: 600;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 25px;
    color: #000;


    svg {
      margin: 0 10px 0 0;
    }
  }

  .inner {
    padding: 25px;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
  }

  .product-image-wrap {
    margin: 15px 0;
    text-align: center;

    img {
      max-width: 100%;
      height: auto;
    }
  }

  .product-info {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .name {

      h4 {
        margin: 0;
        font-size: 16px;
        color: #000;
      }

      p {
        font-size: 12px;
        font-weight: normal;
        line-height: 16px;
        color: #969696;
        margin: 0;
      }
    }

    .add-to-cart {
      .btn-cart {
        padding: 8px 14px;
        display: inline-flex;
        align-items: center;
        background: #fff;
        border: 1px solid #252525;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;
        transition: all .2s;
        cursor: pointer;
        line-height: 1;
        white-space: nowrap;
        margin: 0 0 0 5px;

        &:hover {
          background: #252525;
          color: #fff;

          svg path {
            fill: #fff;
          }
        }

        @media (max-width: 768px) {
          padding: 8px 12px;
        }

        svg {
          margin: 0 0 0 10px;
        }
      }
    }
  }

  .product-description {
    margin: 25px 0;
    color: #969696;
    font-size: 12px;
    line-height: 16px;
  }

  .product-features-wp {
    .feature {
      display: flex;
      margin-bottom: 30px;
      justify-content: space-between;
      align-items: center;

      &:last-child {
        margin-bottom: 0;
      }

      .icon {
        width: 30%;
        text-align: center;
      }
      .caption {
        width: 70%;

        h5 {
          font-weight: 600;
          font-size: 16px;
          line-height: 18px;
          color: #000;
          margin: 0 0 5px 0;
        }

        p {
          font-size: 12px;
          line-height: 16px;
          font-weight: normal;
          color: #969696;
          margin: 0;
        }
      }
    }
  }

  .cart-prompt {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(255, 255, 255, .9);
    }

    .inner {
      max-width: 330px;
      width: 100%;
      margin: 0 30px;
      padding: 20px 25px;
      background: #fff;
      text-align: center;
      box-shadow: 0 10px 12px rgba(26, 26, 26, 0.1);
      border-radius: 10px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: auto;

      @media (max-width: 480px) {
        margin: 0;
      }

      &.compact {
        padding: 40px;
      }

      .product-image-wrap {
        max-width: 120px;
      }

      .name {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 18px;
        color: #3C3C3C;
      }

      .group {
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        color: #969696;
      }

      .btn-cart {
        padding: 10px 24px;
        display: inline-flex;
        background: #252525;
        color: #fff;
        border: 1px solid #fff;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;
        transition: all .2s;
        cursor: pointer;
        line-height: 1;
        margin: 18px 0 13px 0;
        align-items: center;
        white-space: nowrap;

        @media (max-width: 768px) {
          padding: 8px 12px;
        }

        &:hover {
          background: #3c3c3c;
        }

        svg {
          margin: 0 0 0 10px;
        }
      }

      .shipping {
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        color: #969696;
        display: inline-flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
}
</style>
